module.exports = __webpack_public_path__ + "img/menu_arrow.e85647df.svg";